angular.module('accessWebClient').component('accResourceTypeIcon', {
    bindings: {
        node: '=',
        iconClass: '@'
    },
    replace: true,
    controller: [
        'FileExtension',
        'FileTypeIcons',
        'FolderTypeIcons',
        'relativeUrlRootFilter',
        function (FileExtension, FileTypeIcons, FolderTypeIcons, relativeUrlRootFilter) {
            this.getIconName = function () {
                var node = this.node;

                if (node.is_directory && node.is_shared) {
                    return FolderTypeIcons.shared;
                } else if (node.is_directory) {
                    return FolderTypeIcons[node.type] || FolderTypeIcons.folder;
                } else {
                    return FileTypeIcons[FileExtension.getExtension(node.name)] || FileTypeIcons.file;
                }
            };

            this.getStyle = function () {
                var node = this.node;

                return node.is_directory ? { filter: 'url(#accMainColor)' } : {};
            };

            this.getNodeTypeIcon = function () {
                return relativeUrlRootFilter(`/images/file_types/client/${this.getIconName()}.svg`);
            };

            if (!this.iconClass) {
                this.iconClass = 'node-type-icon';
            }
        }
    ],
    template:
        '<svg class="{{ $ctrl.iconClass }}" \
            xmlns="http://www.w3.org/2000/svg" \
            xmlns:xlink="http://www.w3.org/1999/xlink" \
            viewBox="0 0 48 48"> \
            <image \
              height="48" \
              width="48" \
              ng-style="$ctrl.getStyle()" \
              ng-attr-href="{{ $ctrl.getNodeTypeIcon() }}" /> \
        </svg>'
});
